import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemBullets } from '../data/content';
export function SystemOverview() {
  return <section className="bg-navy px-3 py-4 text-white sm:px-6" data-id="element-139" data-mp="18ur5jn4cc488">
      <div className="mx-auto max-w-2xl text-center" data-id="element-140" data-mp="1mmxbyhhoywuh">
        <h2 className="text-lg font-extrabold uppercase leading-tight sm:text-2xl" data-id="element-141" data-mp="1morvbrdbegwg">
          The complete 6-in-1 neurology visual study system
        </h2>
        <p className="mt-1 font-heading text-sm font-extrabold uppercase tracking-wide text-gold sm:text-lg" data-id="element-142" data-mp="tz1fndw1b6y8">
          🧠 NEUROLOGY VISUAL ATLAS™
        </p>
        <p className="mt-1 font-heading text-[0.65rem] font-semibold uppercase tracking-widest text-electric sm:text-xs" data-id="element-143" data-mp="13w67nuck9wmy">
          Visualize • Understand • Connect • Compare • Localize • Review
        </p>
        <ul className="mt-2 grid gap-1 text-left sm:grid-cols-2" data-id="element-144" data-mp="2fb2wp48qwlub">
          {systemBullets.map(b => <li key={b} className="flex items-start gap-1.5 rounded border border-electric/30 bg-white/5 px-2 py-1.5" data-id="element-145" data-mp="2acrnmvq9yfd5">
              <CheckIcon className="mt-0.5 h-3 w-3 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="238gtna76tsr9" />
              <span className="text-xs leading-tight text-white/90 sm:text-sm" data-id="element-147" data-mp="2d5v7d21q83fv">{b}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}